<template>
    <el-dialog
        ref="dialog"
        width="1200px"
        title="编辑"
        class="tpl-edit-dialog"
        top="8vh"
        :close-on-click-modal="false"
        :visible.sync="visible"
        @close="closeAdd"
    >
        <div v-loading="loading" class="tpl-edit-dialog-content">
            <mForm
                ref="dialogForm"
                :dialogForm="config.dialogForm"
                :gutter="config.dialogForm.gutter"
                :mFormValue="editFormData"
                @dialogCheck="dialogCheck"
                @getAddressLabels="getAddressLabels"
                @handleFetchSuggestions="handleFetchSuggestions"
                @handleAutocompleteSelect="handleAutocompleteSelect"
            ></mForm>
            <div class="commodity-table-box">
                <div class="table-model"></div>
                <EditTableBox
                    :selection="config.dialogItemsTable.selection"
                    :control="config.dialogItemsTable.control"
                    :allowRowClick="config.dialogItemsTable.allowRowClick"
                    :height="config.dialogItemsTable.height"
                    :columns="config.dialogItemsTable.columns"
                    :tableData="tableData"
                    @element-change="elementChange"
                />
            </div>
        </div>
        <template v-slot:footer>
            <span class="dialog-footer">
                <div class="add-order-footer-left">
                    <span>
                        <span>数量：{{totalCount}}</span><span class="limit">/</span>
                        <span>体积：{{ totalData.totalVolume || 0}}（m³）</span><span class="limit">/</span>
                        <span>重量：{{ totalData.totalGrossWeight || 0}}（Kg）</span>
                    </span>
                </div>
                <div>
                    <el-button @click="closeAdd">取消</el-button>
                    <lots-button type="primary" @click="submit">确定</lots-button>
                </div>
            </span>
        </template>
    </el-dialog>
</template>
<script>
import _ from 'lodash';
import lotsButton from '@/components/lots/lotsButton';
import EditTableBox from '@/components/lots/editTableBox/Index';
import mForm from '@otp/components/dialog/mForm';
import config from '../js/editConfig.js';
import constConfig from '@otp/utils/constConfig';
import orderDataDict from '@otp/utils/orderDataDict.js';
import { setAddressConfig } from '@otp/utils/common';
import { saveTplCostOrderInfo, getOrderDetailInfo } from '@otp/api/threeplBillingOrder';
import { searchCountryByHistory } from '@otp/api/orderCenter';

const beginTypeArr = ['sender', 'receiver'];
const { REG_ONLY_INT } = constConfig.REG_CONST;
const { TF } = orderDataDict.ORDER_TYPE;
const addrInfoTxt = {
    receiverName: ['receiverProvinceName', 'receiverCityName', 'receiverDistrictName', 'receiverTownName'],
    receiverCode: ['receiverProvinceCode', 'receiverCityCode', 'receiverDistrictCode', 'receiverTownCode'],
    senderName: ['senderProvinceName', 'senderCityName', 'senderDistrictName', 'senderTownName'],
    senderCode: ['senderProvinceCode', 'senderCityCode', 'senderDistrictCode', 'senderTownCode']
};
export default {
    name: 'editDialog',
    components: { mForm, lotsButton, EditTableBox },
    props: {
    },
    data() {
        return {
            visible: false,
            loading: false,
            editFormData: {},

            config: config,
            totalData: {
                totalVolume: 0,
                totalGrossWeight: 0
            },
            tableData: [],
            rowData: []
        };
    },
    computed: {
        totalCount() {
            return this.tableData.reduce((total, num) => {
                const totalCount = +total + (+num.planQty || 0);
                return Math.round(totalCount * 1000) / 1000;
            }, 0);
        },
        totalVolume() {
            return this.tableData.reduce((total, num) => {
                if (!(num.volume || num.grossWeight) || !(num.cdcmCube || num.cdcmWeight)) {
                    return Math.round((+total + (+num.totalVolume)) * 1000000) / 1000000;
                }
                const totalVolume = +total + (num.volume * num.planQty || 0);
                return Math.round(totalVolume * 1000000) / 1000000;
            }, 0);
        },
        totalGrossWeight() {
            return this.tableData.reduce((total, num) => {
                if (!(num.volume || num.grossWeight) || !(num.cdcmCube || num.cdcmWeight)) {
                    return Math.round((+total + (+num.totalGrossWeight)) * 1000000) / 1000000;
                }
                const totalGrossWeight = +total + (num.grossWeight * num.planQty || 0);
                return Math.round(totalGrossWeight * 1000) / 1000;
            }, 0);
        },
        showTargetStatus() {
            const orderType = _.get(this.editFormData, 'orderType', '');
            return orderType === TF;
        }
    },
    methods: {
        countTotal(props) {
            if (!props || !props.length) {
                return;
            }
            const decimal = 1000000; // 保留6位小数
            const keys = {
                volume: 'totalVolume',
                grossWeight: 'totalGrossWeight'
            };
            props.forEach(p => {
                this.totalData[keys[p]] = 0;
            });
            this.tableData.forEach(item => {
                props.forEach(prop => {
                    const totalKey = keys[prop];
                    this.totalData[totalKey] += (Number(item[prop]) * item.planQty);
                });
            });
            props.forEach(p => {
                const val = this.totalData[keys[p]];
                this.totalData[keys[p]] = Math.ceil(val * decimal) / decimal;
            });
        },
        elementChange(data) {
            if (!data) return;
            const { row, val, prop } = data;
            const itemsProps = ['volume', 'grossWeight'];
            if (itemsProps.includes(prop)) {
                row[prop] = val.replace(/[^\d\.]/g, '').replace(/^(\.*)(\d+)(\.?)(\d{0,8}).*$/g, '$2$3$4');
                this.countTotal([prop]);
            }
        },
        handleAutocompleteSelect(data, col) {
            const arr = col.value === 'senderDetailAddr' ? addrInfoTxt.senderName : addrInfoTxt.receiverName;
            this.editFormData[arr[0]] = data.province || '';
            this.editFormData[arr[1]] = data.city || '';
            this.editFormData[arr[2]] = data.area || '';
            this.editFormData[arr[3]] = data.countryName || '';
            this.editFormData[col.value === 'senderDetailAddr' ? 'sendAddress' : 'receiverAddress'] =
                [data.provinceCode, data.cityCode, data.areaCode, data.countryCode];
        },
        handleFetchSuggestions(keywords, cb, col) {
            if (keywords.length < 2) {
                return this.$message.warning(`至少输入两个字符！`);
            }
            const arr = col.value === 'senderDetailAddr' ? addrInfoTxt.senderName : addrInfoTxt.receiverName;
            const frontTxt = arr.reduce((preVal, item) => {
                preVal += this.editFormData[item] || '';
                return preVal;
            }, '');
            keywords = frontTxt + keywords.trim();
            const params = {
                keywords,
                count: 10
            };
            searchCountryByHistory(params).then(res => {
                if (res && +res.code === 0) {
                    res.data.forEach(item => {
                        item.provinces = item.province + item.city + item.area + item.countryName;
                        item.value = item.address.replace(item.provinces, '');
                    });
                    cb(res.data);
                }
            });
        },

        handleNum(val, row, prop) {
            row[prop] = val.replace(/\D/g, '');
        },
        handleFloat(val, row, prop) {
            val = val.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.');
            val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
            row[prop] = val;
        },
        handleSelectionChange(selection) {
            this.rowData = selection;
        },
        getItemsSelectValue(data, label, row, type) {
            row[type] = data[type];
            row[`${type}Name`] = label;
        },
        // 地址组件
        getAddressLabels(value, prop) {
            const beginKey = prop === 'sendAddress' ? beginTypeArr[0] : beginTypeArr[1];
            const { editFormData } = this;
            editFormData[`${beginKey}ProvinceName`] = value[0] || '';
            editFormData[`${beginKey}CityName`] = value[1] || '';
            editFormData[`${beginKey}DistrictName`] = value[2] || '';
            editFormData[`${beginKey}TownName`] = value[3] || '';
        },
        // change
        dialogCheck(value, col) {
            const intArr = ['orderValue'];
            if (col && intArr.includes(col.prop)) {
                value[col.prop] = value[col.prop].replace(REG_ONLY_INT, '');
            }

            this.editFormData = { ...this.editFormData, ...value };
        },
        closeAdd() {
            this.visible = false;
            this.editFormData = {};
        },
        changeMustFill(must = [], unmust = []) {
            const { inputList } = this.config.editDialog.dialogForm;
            inputList.forEach(item => {
                if (must.includes(item.prop)) item.mustFill = true;
                if (unmust.includes(item.prop)) item.mustFill = false;
            });
        },
        async show(data = {}) {
            if (!data.id) {
                return this.$message.warning('订单号有误！');
            }
            this.visible = this.loading = true;
            const res = await getOrderDetailInfo({ orderNo: data.orderNo })
                .finally(() => {
                    this.loading = false;
                });
            if (res && +res.code === 0) {
                data = _.get(res.data, 'tplCostOrderInfo', {});
                if (data.senderProvinceCode && data.senderProvinceName) {
                    data.sendAddress = addrInfoTxt.senderCode.map(addr => data[addr]).filter(i => i);
                }
                if (data.receiverProvinceCode && data.receiverProvinceName) {
                    data.receiverAddress = addrInfoTxt.receiverCode.map(addr => data[addr]).filter(i => i);
                }
                this.editFormData = data;
                this.tableData = _.get(res.data, 'tplCostOrderItem', []);
                this.disposeTableData();
            }
        },
        disposeTableData() {
            this.tableData.forEach(item => {
            });
            this.countTotal(['volume', 'grossWeight']);
        },
        submit() {
            const flag = this.$refs.dialogForm.changeShowMustFill();
            if (flag) {
                this.$message.error('必填项不能为空');
                this.$refs.dialogForm.showMustFill = true;
                return;
            }
            let params = JSON.parse(JSON.stringify(this.editFormData));
            params = {
                ...params,
                ...setAddressConfig(params.sendAddress, addrInfoTxt.senderCode),
                ...setAddressConfig(params.receiverAddress, addrInfoTxt.receiverCode)
            };
            params.items = this.tableData;

            Reflect.deleteProperty(params, '');
            Reflect.deleteProperty(params, 'sendAddress');
            Reflect.deleteProperty(params, 'receiverAddress');
            saveTplCostOrderInfo(params).then(res => {
                if (res && res.code === '0') {
                    this.visible = false;
                    this.$message.success('保存成功');
                    this.$emit('success');
                }
            });
        }
    },
    mounted() {
    }
};
</script>
<style lang="less">
.tpl-edit-dialog {
    .add-order-footer-left {
        float: left;
        font-size: 13px;
        color:#00bcbf;
        .limit {
            margin: 0 12px;
            color: black;
        }
    }
    .commodity-table-box {
        position: relative;
        .el-table .cell > div {
            padding: 0;
            vertical-align: middle;
            line-height: 26px;
        }

    }
}
.autocomplete-content {
    line-height: 24px;
    margin-bottom: 4px;
    .name {
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .addr {
        color: #b4b4b4;
    }
}

</style>
